import { renderBuildAuthorshipAliasBlockCreatedByUserTemplate } from '@next-adapter/templates/renderers/generators/actions/action-helpers/build-authorship-alias-block.js'
export function buildAuthorshipAliasBlock(): string {
  return renderBuildAuthorshipAliasBlockCreatedByUserTemplate()
}
